<template>
  <svg :id="iconId" version="1.1" enable-background="new 0 0 512 512"
       :height="height" viewBox="0 0 512 512" :width="width"
       xmlns="http://www.w3.org/2000/svg">
    <defs>
    </defs>
    <g>
      <g>
        <path id="MyPath" :stroke="stroke_color" :stroke-width="stroke_width" :fill="fill_color"
          :d="path_geometry"/>
      </g>
    </g>
  </svg>
</template>

<script>
import { APP, DEV, getLog } from '../config';
// https://developer.mozilla.org/en-US/docs/Web/SVG/Tutorial/Paths
const MODULE_NAME = 'MySvgIcon';
const log = getLog(MODULE_NAME, 4, 2);

export default {
  name: 'mySvgIcon',
  props: {
    height: {
      type: Number,
      default: 32,
    },
    width: {
      type: Number,
      default: 32,
    },
    stroke_color: {
      type: String,
      default: 'black',
    },
    stroke_width: {
      type: String,
      default: '2px',
    },
    fill_color: {
      type: String,
      default: '#0000FF',
    },
    path_geometry: {
      type: String,
      default: `m 340.79772,159.40601 q 0,-33.77826 -24.57037,-55.11191 -23.97109,-21.333638 -58.72916,-21.333638 -71.91326,0 -85.09736,86.519778 l -54.53422,-6.51862 q 15.5812,-122.668446 139.0323,-122.668446 59.32844,0 98.28146,30.81526 38.95302,30.222656 38.95302,84.741976 0,20.14844 -11.38627,40.29688 -10.78699,20.14844 -24.57036,34.37086 -13.1841,13.62984 -30.56314,30.81527 -17.37903,17.18544 -24.57037,27.85225 -19.77614,28.44486 -20.37542,78.22336 h -53.33566 v -24.29665 q 0,-23.70405 8.98916,-45.03769 9.58843,-21.92625 20.37542,-33.18567 1.79783,-2.3704 27.56675,-24.88924 25.76891,-23.11145 40.15157,-42.66729 14.38265,-19.55584 14.38265,-37.92648 z M 226.33578,471.70683 v -59.26011 h 59.92772 v 59.26011 z
      `,
    },
    iconId: {
      type: String,
      default: 'youricon',
    },
  },
  data: () => ({
    appName: APP,
    isInDev: DEV,
  }),
  created() {
    log.t(`# ${MODULE_NAME} created()`);
  },
  mounted() {
    log.t(`# ${MODULE_NAME} mounted()`);
  }, // end of mounted
};
</script>
